






































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import SelectableEntity from '@/models/Shared/SelectableEntity';
import RejectAppliedBookingRoleWorkerRequest from '@/models/BookingRoleWorkers/RejectAppliedBookingRoleWorkerRequest'
import BookingRoleWorkerShiftDto from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftDto';
import BookingRoleWorkerShiftStatus from '@/components/BookingRoleWorkerShifts/Display/BookingRoleWorkerShiftStatus.vue';
import BookingRoleWorkerShiftStatusEnum from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftStatus';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ListUtils from '@/lib/listUtils';

@Component({
    name: 'BookingManageWorkersReject', 
    components: { BookingRoleWorkerShiftStatus }
})
export default class extends GiganautVueDialog {

  @Prop()
  selectedBookingRole: BookingRoleDto;
	bookingRoleWorkerShiftStatusEnum = BookingRoleWorkerShiftStatusEnum;
  request: RejectAppliedBookingRoleWorkerRequest = new RejectAppliedBookingRoleWorkerRequest
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
  
    if (val) {
      this.request = new RejectAppliedBookingRoleWorkerRequest();
    }
  }

  get shifts() {
    return BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.bookingRoleWorkerShifts.filter(
        bookingRoleWorkerShift => bookingRoleWorkerShift.status === BookingRoleWorkerShiftStatusEnum.Applied
      )
  }

  get canReject() {
    for (let index = 0; index < BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.bookingRoleWorkerShifts.length; index++) {
      const element = BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.bookingRoleWorkerShifts[index];
      if (element.status > BookingRoleWorkerShiftStatusEnum.Applied) {
        return false;
      }
    }
    return true;
  }

  get loading() {
    return BookingDetailsModule.loadingDialog;
  }

  get selectedWorker() {
      return BookingDetailsModule.offeredWorkersVM.selectedWorker;
  }

  get rejectedReasons() {
    return ListUtils.bookingRoleWorkerShiftRejectedReasons();
  }

  get summaries() {
    return BookingDetailsModule.offeredWorkersVM.availabilitySummariesForBook;
  }
	  
  async reject() { 
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await BookingDetailsModule.rejectAppliedBookingRoleWorker(this.request);
    await BookingDetailsModule.updateOfferedSelectedBookingRole(this.selectedBookingRole);
    await BookingDetailsModule.updateBookedSelectedBookingRole(this.selectedBookingRole);
    this.dialog = false;
  }
}
